import { useCallback, useState } from "react";

// The opacity each hazard overlay renders at by default. The opacity slider
// starts at these values (instead of a flat 100%) and can be raised up to 1,
// i.e. fully opaque. Hazard overlay layers apply the slider value directly as
// their real opacity.
export const DEFAULT_LAYER_OPACITIES = {
  fire: 0.5,
  flood: 0.6,
  earthquake: 0.56,
};

export function useLayerOpacities() {
  const [layerOpacities, setLayerOpacities] = useState(DEFAULT_LAYER_OPACITIES);

  const setLayerOpacity = useCallback((risk, value) => {
    setLayerOpacities((prev) => ({ ...prev, [risk]: value }));
  }, []);

  return { layerOpacities, setLayerOpacity };
}

// For data-driven layers whose opacity is set per feature (e.g. the portfolio
// choropleth), the slider can't map to a single opacity value, so it acts as a
// multiplier instead: convert the slider value into the factor that leaves the
// per-feature opacities unchanged at the default slider position (factor 1) and
// scales them toward full opacity as the slider approaches its maximum.
export function layerOpacityFactor(risk, opacity) {
  return opacity / DEFAULT_LAYER_OPACITIES[risk];
}
